module.exports = __webpack_public_path__ + "static/media/ts2tj54.99951cb9.png";